<template>
	<v-app v-scroll.self="onScroll">
		<v-navigation-drawer
			v-if="!isPresentationMode"
			v-model="drawer"
			:mini-variant="miniVariant"
			disable-resize-watcher
			app
			right
			touchless
		>
			<v-layout
				column
				fill-height
			>
				<v-list class="sideMenu mt-2">
					<template
						v-for="(link, i) in sitemap"
					>
						<v-list-item
							:key="`drawerMenu-${i}`"
							class="d-block"
							dense
						>
							<template v-if="link.items">
								<v-list-group>
									<template v-slot:activator>
										<v-list-item-content>{{ link.text }}</v-list-item-content>
									</template>
									<v-list-item
										v-for="(sub, j) in link.items"
										:key="`drawerMenu-${i}-${j}`"
										class="d-block"
										dense
									>
										<v-btn
											:to="sub.to"
											exact
											text
											href
											block
											class="justify-start"
										>
											{{ sub.text }}
										</v-btn>
									</v-list-item>
								</v-list-group>
								<v-divider :key="`drawerMenu-d-${i}`" />
							</template>
							<template v-else>
								<v-btn
									:to="link.to"
									exact
									text
									href
									block
									class="justify-start"
								>
									{{ link.text }}
								</v-btn>
								<v-divider :key="`drawerMenu-d-${i}`" />
							</template>
						</v-list-item>
					</template>
				</v-list>
				<v-spacer />
				<div class="social bgDark">
					<a
						href="https://www.facebook.com/thebestpropertyhome"
						title="ติดตาม The Best Property  บนเฟสบุ๊ค"
						target="_blank"
					>
						<img
							src="/images/icon/facebook.png"
							alt=""
						>
					</a>
					<a
						href="https://m.me/thebestpropertyhome"
						title="สนทนากับ The Best Property"
						target="_blank"
					>
						<img
							src="/images/icon/messenger.png"
							alt=""
						>
					</a>
					<a
						href="https://line.me/ti/p/@thebestproperty"
						title="ไลท์แชทกับ The Best Property  ไอดี @thebestproperty"
						target="_blank"
					>
						<img
							src="/images/icon/line.png"
							alt=""
						>
					</a>
				</div>
			</v-layout>
		</v-navigation-drawer>

		<client-only>
			<v-app-bar
				v-if="_isMounted && showExtendfilter"
				class="miniFilter"
				extension-height="56"
				scroll-threshold="200"
				app
				elevate-on-scroll
				extended
				:inverted-scroll="invertedScroll"
			>
				<template v-slot:extension="{ }">
					<miniFilter
						v-if="isMobile"
						ref="miniFilter"
					/>
					<v-container v-else>
						<v-row no-gutters>
							<v-col
								xl="8"
								offset-xl="2"
							>
								<v-row no-gutters>
									<v-col
										lg="10"
										offset-lg="1"
									>
										<fullSearchForm
											ref="fullSearchFormAppBar"
											:params="$route.query"
											class="px-9"
										/>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</v-container>
				</template>
			</v-app-bar>

			<!-- Appbar mobile -->
			<v-app-bar
				v-if="isMobile && !['guest-register','agent-register', 'property-contract', 'property-contract-v2'].includes($route.name)"
				app
				:elevation="0"
			>
				<n-link
					:to="isPresentationMode ? '' : { name: 'index' }"
					title="หน้าหลัก"
				>
					<img
						src="/images/LOGO.TB.CO.TH.png"
						alt=""
						class="logo d-inline-block"
					>
				</n-link>
				<v-spacer />
				<v-spacer />
				<v-spacer />
				<v-slide-y-reverse-transition v-if="!isPresentationMode">
					<div v-if="showMiniFilterLabel">
						เลือกตัวกรอง
					</div>
				</v-slide-y-reverse-transition>
				<v-spacer />
				<client-only>
					<div class="d-inline-block iconSearch sectionBorder">
						<fullSearchFormMobile
							v-if="!isPresentationMode"
							ref="mobileSearchComponent"
							:params="$route.query"
						/>
					</div>
				</client-only>
				<div class="favorite">
					<favoriteProps v-if="!isPresentationMode" />
				</div>
				<v-app-bar-nav-icon
					v-if="!isPresentationMode"
					color="white"
					@click.stop="drawer = !drawer"
				/>
			</v-app-bar>

			<!-- Appbar desktop -->
			<v-app-bar
				v-else
				app
				:elevation="0"
			>
				<v-container v-if="!['guest-register', 'agent-register', 'property-contract', 'property-contract-v2'].includes($route.name)">
					<v-row no-gutters>
						<v-col
							xl="8"
							offset-xl="2"
						>
							<v-row>
								<v-col
									cols="4"
									md="1"
									xl="1"
								>
									<n-link
										:to="isPresentationMode ? '' : { name: 'index' }"
										title="หน้าหลัก"
									>
										<img
											src="/images/LOGO.TB.CO.TH.png"
											alt=""
											class="logo d-inline-block"
										>
									</n-link>
								</v-col>
								<v-col
									class="text-center d-none d-md-block"
									md="10"
									xl="10"
								>
									<nav v-if="!isPresentationMode">
										<ul class="nav">
											<li
												v-for="(link, i) in sitemap"
												:key="`sitemap-${i}`"
											>
												<template v-if="link.items">
													<v-menu
														content-class="sub-menu-header"
														offset-y
													>
														<template #activator="{ attrs, on }">
															<a
																:title="link.text"
																v-bind="attrs"
																v-on="on"
															>
																{{ link.text }}
															</a>
														</template>

														<v-list>
															<v-list-item
																v-for="(sub, j) in link.items"
																:key="`sitemap-${i}-${j}`"
																link
															>
																<n-link
																	:to="sub.to"
																	:title="sub.text"
																	:event="sub.event || 'click'"
																	class="py-3 flex-grow-1"
																>
																	{{ sub.text }}
																</n-link>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>

												<n-link
													v-else
													:to="link.to"
													:title="link.text"
													:event="link.event || 'click'"
												>
													{{ link.text }}
												</n-link>
											</li>
										</ul>
									</nav>
								</v-col>
								<v-col
									cols="8"
									md="1"
									xl="1"
									class="d-flex justify-end align-center"
								>
									<div class="d-inline-block favorite">
										<favoriteProps v-if="!isPresentationMode" />
									</div>
									<div class="d-inline-block d-md-none">
										<v-app-bar-nav-icon
											v-if="!isPresentationMode"
											@click.stop="drawer = !drawer"
										/>
									</div>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-container>

				<v-container v-if="['guest-register'].includes($route.name)">
					<v-row no-gutters>
						<v-col
							xl="8"
							offset-xl="2"
						>
							<v-row>
								<v-col
									cols="4"
									md="1"
									xl="1"
								>
									<n-link
										:to="isPresentationMode ? '' : { name: 'index' }"
										title="หน้าหลัก"
									>
										<img
											src="/images/2.0/LOGO.TB.CO.TH.png"
											alt=""
											class="logo d-inline-block"
										>
									</n-link>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-container>
			</v-app-bar>
		</client-only>
		<!-- Appbar -->

		<!-- Layout -->
		<nuxt
			keep-alive
			:keep-alive-props="{ include: keepAlivePages }"
			:class="isMobile ? 'mobile' : '' + (showExtendfilter ? 'hasFilter' : '')"
		/>

		<footer v-if="hasFooter">
			<div
				v-if="false"
				class="bgDark white--text"
			>
				<v-container class="pb-0">
					<v-row no-gutters>
						<v-col
							xl="8"
							offset-xl="2"
							class="borderBtmContent"
						>
							<v-row>
								<v-col class="text-center">
									<h2 class="text-center mb-0">
										โครงการ<span class="colorRed">มาใหม่!!!</span>
									</h2>
								</v-col>
							</v-row>
							<v-row class="list">
								<v-skeleton-loader
									v-if="newProps.length == 0"
									class="mx-auto"
									width="100%"
									type="card-avatar"
								/>

								<newPropertyListItem
									v-for="prop in newProps"
									:id="prop"
									:key="prop"
								/>
							</v-row>
							<v-row class="my-5">
								<v-col
									cols="4"
									class="mx-auto"
								>
									<button class="btnMore bgRed">
										ดูเพิ่มเติม
									</button>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-container>
			</div>
			<div
				v-if="!['guest-register', 'agent-register', 'property-contract', 'property-contract-v2'].includes($route.name)"
				class="bgDark white--text"
			>
				<v-container>
					<v-row no-gutters>
						<v-col
							xl="8"
							offset-xl="2"
							class="listFooter"
						>
							<v-row v-if="!isPresentationMode">
								<v-col
									v-for="(col, i) in scLinks"
									:key="`col-${i}`"
									cols="12"
									sm="6"
									lg="3"
								>
									<div
										class="head-text mb-3"
									>
										{{ col.name }}
									</div>
									<ul class="list-unstyled siteMap">
										<li
											v-for="link in col.links"
											:key="link.text"
										>
											<n-link
												:to="link.to"
												:title="link.text"
											>
												{{ link.text }}
											</n-link>
										</li>
									</ul>
								</v-col>
							</v-row>
							<v-row>
								<v-col
									v-if="!isPresentationMode"
									cols="12"
									sm="6"
									lg="3"
								>
									<div
										class="head-text mb-3"
										style="text-transform: capitalize;"
									>
										| Sitemap
									</div>
									<ul class="list-unstyled siteMap">
										<template v-for="(link, i) in sitemap">
											<template v-if="link.items">
												<li
													v-for="(sub, j) in link.items"
													:key="`sitemap-${i}-${j}`"
												>
													<n-link
														:to="sub.to"
														:title="sub.text"
														:event="sub.event || 'click'"
													>
														{{ sub.text }}
													</n-link>
												</li>
											</template>
											<li
												v-else
												:key="`sitemap-${i}`"
											>
												<n-link
													:to="link.to"
													:title="link.text"
													:event="link.event || 'click'"
												>
													{{ link.text }}
												</n-link>
											</li>
										</template>
									</ul>
								</v-col>
								<v-col
									v-if="!isPresentationMode"
									cols="12"
									sm="6"
									lg="3"
								>
									<div
										class="head-text mb-3"
									>
										| the best property
									</div>
									<p>บริษัท เดอะ เบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด<br>ผู้นำด้านการซื้อขายอสังหาริมทรัพย์ทุกประเภท</p>
								</v-col>
								<v-col
									v-if="!isPresentationMode"
									cols="12"
									sm="6"
									lg="3"
									class="contact"
								>
									<div
										class="head-text mb-3"
										style="text-transform: capitalize;"
									>
										| Address
									</div>
									<p class="mb-0">
										สำนักงานใหญ่ เลขที่ 40/88 ซอยมัณฑนา หมู่ 5<br>
										ตำบลบางเมือง อำเภอเมือง จังหวัดสมุทรปราการ
									</p>
									<p class="mb-0">
										โทร :
										<a
											href="tel:02-047-4282"
											title="ติดต่อ The Best Property  ทางโทรศัพท์ โทร 02-047-4282"
											style="color: #f13120;"
										>02-047-4282</a>
									</p>
									<!-- <p class="mb-0">
										Email : <a
											href="mailto:Thebestproperty99@gmail.com"
											title="อีเมล Thebestproperty99@gmail.com"
											target="_blank"
										>Thebestproperty99@gmail.com</a>
									</p> -->
								</v-col>
								<v-col
									v-if="!isPresentationMode"
									cols="12"
									sm="6"
									lg="3"
									class="social"
								>
									<div
										class="head-text mb-3"
										style="text-transform: capitalize;"
									>
										| Contact Us
									</div>
									<div class="d-flex">
										<v-btn
											href="tel:02-047-4282"
											color="white"
											width="26"
											height="26"
											dark
											fab
											small
										>
											<v-icon
												color="grey darken-3"
												small
											>
												mdi-phone
											</v-icon>
										</v-btn>
										<a
											href="https://line.me/ti/p/@thebestproperty"
											title="ไลท์แชทกับ The Best Property  ไอดี @thebestproperty"
											target="_blank"
										>
											<img
												src="/images/icon/line.png"
												alt=""
											>
										</a>
										<a
											href="https://m.me/thebestpropertyhome"
											title="สนทนากับ The Best Property"
											target="_blank"
										>
											<img
												src="/images/icon/messenger.png"
												alt=""
											>
										</a>
										<a
											href="https://www.facebook.com/thebestpropertyhome"
											title="ติดตาม The Best Property  บนเฟสบุ๊ค"
											target="_blank"
										>
											<img
												src="/images/icon/facebook.png"
												alt=""
											>
										</a>
									</div>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-container>
			</div>
			<div class="bgRed white--text">
				<v-container>
					<v-row no-gutters>
						<v-col
							xl="8"
							offset-xl="2"
							class="footer text-center"
						>
							<p class="mb-0">
								The Best Property Agent Co.,Ltd. Copyright {{ new Date().getFullYear() }}. All Rights Reserved
							</p>
							<!-- <p class="mb-0">
								Compatible <v-icon>mdi-internet-explorer</v-icon><v-icon>mdi-apple-safari</v-icon><v-icon>mdi-firefox</v-icon><v-icon>mdi-apple</v-icon><v-icon>mdi-android-debug-bridge</v-icon>, Tools <v-icon>mdi-language-html5</v-icon><v-icon>mdi-language-css3</v-icon><v-icon>mdi-bitbucket</v-icon>
							</p> -->
						</v-col>
					</v-row>
				</v-container>
			</div>

			<client-only>
				<cookie-law
					theme="blood-orange"
					button-text="ยอมรับ"
					message="เว็บไซต์ของ THE BEST PROPERTY AGENT ใช้คุกกี้เพื่อให้เว็บไซต์ทำงานได้อย่างถูกต้อง และช่วยปรับปรุงประสบการณ์การใช้งานของคุณเท่านั้น เราไม่ใช้คุกกี้เพื่อเก็บข้อมูลส่วนบุคคล หรือเพื่อติดตามการใช้งานของคุณในเชิงโฆษณา การกดปุ่ม “ยอมรับ” หมายถึงคุณยอมรับการใช้งานคุกกี้พื้นฐานที่จำเป็นต่อการทำงานของเว็บไซต์เท่านั้น"
				/>
			</client-only>
		</footer>
	</v-app>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex'
import favoriteProps from '~/components/favorite-props'
import fullSearchFormMobile from '~/components/full-search-form-mobile'
import newPropertyListItem from '~/components/new-property-list-item'
import fullSearchForm from '~/components/full-search-form'
import miniFilter from '~/components/mini-filter'

export default {
	components: {
		favoriteProps,
		fullSearchFormMobile,
		newPropertyListItem,
		fullSearchForm,
		miniFilter,
		CookieLaw: () => process.client ? import('vue-cookie-law') : null
	},

	data() {
		return {
			drawer: false,
			miniVariant: false,
			invertedScroll: true,
			showMiniFilterLabel: false,
			keepAlivePages: [
				'INDEX',
				'LIST',
				'MAP',
				'AGENT',
				'PORTFOLIO',
				'Samutprakan'
			],

			sitemap: [
				{ to: { name: 'index' }, text: 'หน้าหลัก' },
				{ to: '/search?tx=BUY&market=REST', text: 'ขาย' },
				{ to: '/search?tx=RENT&market=REST', text: 'เช่า' },
				// { to: '/map-search', text: 'ค้นหา (แผนที่)', event: (this.$route.path === '/map-search' ? '' : 'click') },
				// { to: '/promotion', text: 'โปรโมชั่น 5 คุ้ม' },
				{ to: '/agent', text: 'ค้นหาตัวแทน' },
				{ to: { name: 'service' }, text: 'บริการของเรา' },
				{ to: '/portfolio', text: 'ผลงานของเรา' },
				{
					to: '/blog',
					text: 'บทความ',
					items: [
						{ to: '/blog/review', text: 'รีวิว' },
						{ to: '/blog/tips', text: 'สาระน่ารู้' },
						{ to: '/blog/home-knowledge', text: 'ความรู้เรื่องบ้าน' },
					]
				}
			],

			scLinks: [
				{
					name: '| ประกาศขายบ้านในกรุงเทพฯ',
					links: [
						{ to: '/bangkok/singlehome', text: 'ขายบ้านเดี่ยว กรุงเทพฯ' }, // search?province=1&tx=BUY&market_selected=HOME
						{ to: '/bangkok/townhome', text: 'ขายทาวน์เฮ้าส์ กรุงเทพฯ' }, // search?province=1&tx=BUY&market_selected=TOWNHOUSE
						{ to: '/bangkok/condo', text: 'ขายคอนโด กรุงเทพฯ' }, // search?province=1&tx=BUY&market_selected=CONDO
						{ to: '/search?province=1&tx=BUY&market_selected=LAND', text: 'ขายที่ดิน กรุงเทพฯ' },
						{ to: '/search?province=1&market_selected=HOME&minprice=2000000&tx=BUY&order=min-price', text: 'ขายบ้านเดี่ยว กรุงเทพฯ เริ่มต้น 2 ล้านบาท' },
						{ to: '/search?province=1&market_selected=TOWNHOUSE&minprice=1000000&tx=BUY&order=min-price', text: 'ขายทาวน์เฮ้าส์ กรุงเทพฯ เริ่มต้น 1 ล้านบาท' },
						{ to: '/search?province=1&market_selected=CONDO&tx=BUY&minprice=1000000&order=min-price', text: 'ขายคอนโด กรุงเทพฯ เริ่มต้น 1 ล้านบาท' },
						// { to: '/promotion?province=1&tx=BUY&market=REST', text: 'ขายบ้านมือสองกรุงเทพฯ โปรโมชั่นพิเศษ' },
					]
				},
				{
					name: '| ประกาศขายบ้านในสมุทรปราการ',
					links: [
						{ to: '/samut-prakan/singlehome', text: 'ขายบ้านเดี่ยว สมุทรปราการ' },
						{ to: '/samut-prakan/townhome', text: 'ขายทาวน์เฮ้าส์ สมุทรปราการ' },
						{ to: '/samut-prakan/condo', text: 'ขายคอนโด สมุทรปราการ' },
						{ to: '/search?province=2&tx=BUY&market_selected=LAND', text: 'ขายที่ดิน สมุทรปราการ' },
						{ to: '/search?province=2&market_selected=HOME&minprice=2000000&tx=BUY&order=min-price', text: 'ขายบ้านเดี่ยว สมุทรปราการ เริ่มต้น 2 ล้านบาท' },
						{ to: '/search?province=2&market_selected=TOWNHOUSE&minprice=1000000&tx=BUY&order=min-price', text: 'ขายทาวน์เฮ้าส์ สมุทรปราการ เริ่มต้น 1 ล้านบาท' },
						{ to: '/search?province=2&market_selected=CONDO&minprice=1000000&tx=BUY&order=min-price', text: 'ขายคอนโด สมุทรปราการ เริ่มต้น 1 ล้านบาท' },
						// { to: '/promotion?province=2&tx=BUY&market=REST', text: 'ขายบ้านมือสองสมุทรปราการ โปรโมชั่นพิเศษ' },
					]
				},
				{
					name: '| ประกาศขายบ้านในนนทบุรี',
					links: [
						{ to: '/nonthaburi/singlehome', text: 'ขายบ้านเดี่ยว นนทบุรี' }, // search?province=3&tx=BUY&market_selected=HOME
						{ to: '/nonthaburi/townhome', text: 'ขายทาวน์เฮ้าส์ นนทบุรี' }, // search?province=3&tx=BUY&market_selected=TOWNHOUSE
						{ to: '/nonthaburi/condo', text: 'ขายคอนโด นนทบุรี' }, // search?province=3&tx=BUY&market_selected=CONDO
						{ to: '/search?province=3&tx=BUY&market_selected=LAND', text: 'ขายที่ดิน นนทบุรี' },
						{ to: '/search?province=3&market_selected=HOME&minprice=2000000&tx=BUY&order=min-price', text: 'ขายบ้านเดี่ยว นนทบุรี เริ่มต้น 2 ล้านบาท' },
						{ to: '/search?province=3&market_selected=TOWNHOUSE&minprice=1000000&tx=BUY&order=min-price', text: 'ขายทาวน์เฮ้าส์ นนทบุรี เริ่มต้น 1 ล้านบาท' },
						{ to: '/search?province=3&market_selected=CONDO&minprice=1000000&tx=BUY&order=min-price', text: 'ขายคอนโด นนทบุรี เริ่มต้น 1 ล้านบาท' },
						// { to: '/promotion?province=3&tx=BUY&market=REST', text: 'ขายบ้านมือสองนนทบุรี โปรโมชั่นพิเศษ' },
					]
				},
				{
					name: '| ประกาศขายบ้านในชลบุรี',
					links: [
						{ to: '/chonburi/singlehome', text: 'ขายบ้านเดี่ยว ชลบุรี' }, // search?province=11&tx=BUY&market_selected=HOME
						{ to: '/chonburi/townhome', text: 'ขายทาวน์เฮ้าส์ ชลบุรี' }, // search?province=11&tx=BUY&market_selected=TOWNHOUSE
						{ to: '/chonburi/condo', text: 'ขายคอนโด ชลบุรี' }, // search?province=11&tx=BUY&market_selected=CONDO
						{ to: '/search?province=11&tx=BUY&market_selected=LAND', text: 'ขายที่ดิน ชลบุรี' },
						{ to: '/search?province=11&market_selected=HOME&minprice=2000000&tx=BUY&order=min-price', text: 'ขายบ้านเดี่ยว ชลบุรี เริ่มต้น 2 ล้านบาท' },
						{ to: '/search?province=11&market_selected=TOWNHOUSE&minprice=1000000&tx=BUY&order=min-price', text: 'ขายทาวน์เฮ้าส์ ชลบุรี เริ่มต้น 1 ล้านบาท' },
						{ to: '/search?province=11&market_selected=CONDO&minprice=1000000&tx=BUY&order=min-price', text: 'ขายคอนโด ชลบุรี เริ่มต้น 1 ล้านบาท' },
						// { to: '/promotion?province=11&tx=BUY&market=REST', text: 'ขายบ้านมือสองชลบุรี โปรโมชั่นพิเศษ' },
					]
				}
			]
		}
	},

	computed: {
		...mapGetters(['isMobile', 'hasFooter', 'latestUpdated', 'newProps']),

		showExtendfilter () {
			return ['/', '/search', '/promotion'].includes(this.$route.path) || ['samut-prakan'].includes(this.$route.name)
		},

		isPresentationMode () {
			return this.$route.path.indexOf('/property-presentation') === 0 || [
				'property-contract-v2',
				'property-contract'
			].includes(this.$route.name)
		}
	},

	watch: {

	},

	created() {
		if (process.client) {
			// Inspect user device for first access
			this.deviceInspect()
		}
	},

	mounted() {
		window.windowNavigate = false
		window.addEventListener('popstate', this.backHandler, false) //backbutton
	},

	beforeDestroy () {
		window.removeEventListener('popstate', this.backHandler) //backbutton
	},

	methods: {
		...mapMutations({
			deviceInspect: 'deviceInspect'
		}),

		backHandler () {
			window.windowNavigate = true
		},

		onScroll (e) {
			if (this.showExtendfilter) {
				if (e.target.scrollingElement.scrollTop > 220) {
					this.$nextTick(() => {
						this.showMiniFilterLabel = true
					})
				} else {
					this.$nextTick(() => {
						this.showMiniFilterLabel = false
					})
				}
			}
		}
	}
}
</script>

<style lang="scss" scoped>
	main {
		&.v-content, &.v-content.mobile, &.v-content.hasFilter {
			padding-top: 56px !important;
		}
	}
  .footer i { color: #fff; font-size: 16px; }
  .sideMenu::v-deep {
		.v-list-group__header {
			min-height: 40px;
			font-size: 0.875rem;
		}
    a { text-decoration: none; color: #000; margin: 1px 0 2px 0; }
	}
	.sub-menu-header {
		box-shadow: unset;
		.v-list.v-sheet {
			background-color: #c20000;

			a {
				text-decoration: none;
				color: #fff;
			}
		}
	}
	.v-navigation-drawer {
		.v-divider {
			flex: 1 0 100% !important;
		}

		.social {
			text-align: center;
			padding: 10px 0;

			a {
				margin-right: 5px;
			}
			img {
				height: 50px;
			}
		}
	}
	.search {
		background: transparent;
		border-radius: 0;
		padding: 0;
	}
	.miniFilter::v-deep {
		> .v-toolbar__extension {
			padding: 4px;

			> .inputSelect > div:not(:last-child) {
				max-width: 30%;
			}
		}
	}
</style>
